// Default settings for the application
const defaultSettings = {
  themeMode: 'light',
  // Default to light mode for the application
  keeniconsStyle: 'filled',
  // Default to using filled KeenIcons style
  container: 'fixed' // Default container layout is set to fixed
};
export { defaultSettings };